import { Trans, useTranslation } from "react-i18next";
import track from "../assets/images/tracks.png";

const Responsibility = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-screen-xl mx-4 mt-11 flex flex-col-reverse lg:mt-24 lg:flex-row lg:gap-x-8 2xl:mx-auto">
      <div className="mt-8 shrink-0 lg:mt-0 lg:w-2/4 xl:w-[747px] lg:h-[404px]">
        <img src={track} alt="track" />
      </div>
      <div>
        <h2 className="text-4xl leading-10 font-Roboto font-bold mb-8">
          {t("Verantwortung übernehmen")}
        </h2>
        <div className="font-Roboto">
          <Trans>
						Bei allsafe liegt uns die Umwelt am Herzen, und aus diesem Grund
						setzen wir auf nachhaltigeres Aluminium. Unsere Verantwortung als
						Unternehmen motiviert uns dazu, nachhaltige Lösungen in unserem
						Geschäftsbetrieb zu verankern. Durch die Verwendung von
						nachhaltigerem Aluminium optimieren wir unseren ökologischen
						Fußabdruck. Wir setzen auf die Produktion in Europa, um
						Transportwege zu minimieren. Durch den Einsatz erneuerbarer
						Energiequellen, wird der CO2-Ausstoß während der Produktion gesenkt.
						Das können Sie auch!
          </Trans>
        </div>
      </div>
    </div>
  );
};

export default Responsibility;
